module.exports = __webpack_public_path__ + "img/一桌好菜近景.b1a0809d.png";